import { useLoader } from '@react-three/fiber';
import { SRGBColorSpace, TextureLoader } from 'three';

import { publicAssets } from 'utils/gcs';

export const TEXTURE_PATHS = {
  day: publicAssets('/earth/textures/earth.jpg'),
  night: publicAssets('/earth/textures/night.jpg'),
  specularClouds: publicAssets('/earth/textures/specularClouds.jpg'),
};

export const useEarthTextures = () => {
  const [earthDayTexture, earthNightTexture, earthSpecularCloudsTexture] =
    useLoader(TextureLoader, [
      TEXTURE_PATHS.day,
      TEXTURE_PATHS.night,
      TEXTURE_PATHS.specularClouds,
    ]);

  const textures = [
    earthDayTexture,
    earthNightTexture,
    earthSpecularCloudsTexture,
  ];

  // Set sRGB colorspace and reduce anisotropy
  textures.forEach(texture => {
    texture.colorSpace = SRGBColorSpace;
    texture.anisotropy = 2;
  });

  return {
    earthDayTexture,
    earthNightTexture,
    earthSpecularCloudsTexture,
  };
};
